import cx from 'classnames'
import Form from 'react-bootstrap/Form'
import Typography from '../../Typography/Typography'

import './RadioGroup.scss'

const RadioGroup = ({ children, label, error, touched, className, ...props }) => {
    const isError = error && touched

    return (
        <Form.Group className={cx('radio-group', className)} {...props}>
            <Form.Check.Label className={'mb-1'}>
                <Typography variant={'formLabel'} color={isError ? 'error' : 'primary'}>
                    {label}
                </Typography>
            </Form.Check.Label>
            <Form.Group className={'radio-group--content d-flex'}>{children}</Form.Group>
            {isError && (
                <Form.Control.Feedback type={'invalid'} className={cx(isError && 'd-block m-0')}>
                    <Typography variant={'formDescription'} color={'error'} className={'position-absolute'}>
                        {error}
                    </Typography>
                </Form.Control.Feedback>
            )}
        </Form.Group>
    )
}

export default RadioGroup
